import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    console.log('Logs controller connected')
    this.searchTimeout = null
  }

  disconnect() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  }

  async refresh() {
    console.log('Refreshing logs...')
    await this.submitForm()
  }

  async filterChanged() {
    console.log('Filter changed, submitting form...')
    await this.submitForm()
  }

  async clearSearch() {
    console.log('Clearing search...')
    const searchField = this.formTarget.querySelector('input[name="search"]')
    if (searchField) {
      searchField.value = ''
      await this.submitForm()
    }
  }

  async clearAllFilters() {
    console.log('Clearing all filters...')
    
    // Clear search
    const searchField = this.formTarget.querySelector('input[name="search"]')
    if (searchField) {
      searchField.value = ''
    }
    
    // Uncheck all checkboxes
    const checkboxes = this.formTarget.querySelectorAll('input[type="checkbox"]')
    checkboxes.forEach(checkbox => {
      checkbox.checked = false
    })
    
    await this.submitForm()
  }

  async removeFilter(event) {
    const filterType = event.currentTarget.dataset.filterType
    const filterValue = event.currentTarget.dataset.filterValue
    
    console.log(`Removing ${filterType} filter: ${filterValue}`)
    
    if (filterType === 'level') {
      const checkbox = this.formTarget.querySelector(`input[name="level[]"][value="${filterValue}"]`)
      if (checkbox) {
        checkbox.checked = false
      }
    } else if (filterType === 'source') {
      const checkbox = this.formTarget.querySelector(`input[name="source[]"][value="${filterValue}"]`)
      if (checkbox) {
        checkbox.checked = false
      }
    }
    
    await this.submitForm()
  }

  async submitForm() {
    if (!this.hasFormTarget) {
      console.error('Form target not found')
      return
    }

    const formData = new FormData(this.formTarget)
    const currentUrl = new URL(window.location)
    
    // Build URL with form data
    const searchParams = new URLSearchParams()
    
    // Log form data for debugging
    console.log('Form data entries:')
    for (const [key, value] of formData.entries()) {
      console.log(`  ${key}: ${value}`)
      if (value) {
        searchParams.append(key, value)
      }
    }
    
    // Ensure we stay on logs tab
    searchParams.set('tab', 'logs')
    
    const requestUrl = `${currentUrl.origin}${currentUrl.pathname}?${searchParams.toString()}`
    
    console.log('Making Turbo Stream request to:', requestUrl)

    try {
      const response = await fetch(requestUrl, {
        method: 'GET',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const turboStreamContent = await response.text()
        Turbo.renderStreamMessage(turboStreamContent)
        
        // Update URL without page reload
        history.pushState(null, '', requestUrl)
        console.log('Logs updated successfully')
      } else {
        console.error('Failed to fetch logs update:', response.status)
      }
    } catch (error) {
      console.error('Error updating logs:', error)
    }
  }
}